import axiosServices from "../utils/axios";

export const addPortCallNotification= async (data:  { agentOnly: boolean; hqOnly: boolean; email_introduction: string; pcid: string, attachmentList:any, includeCC:boolean}) => {
  const response = await axiosServices.post(`/reports/portcallnotification`, data);
  return (response);
};

export const getPortCallNotification = async (params: { agentOnly: boolean; pcid: string; hqOnly: boolean; showCompletedBerth: boolean; version?: "v1" | "v2" }) => {
  const { agentOnly, pcid, hqOnly, showCompletedBerth, version = "v1" } = params;
  const endpoint = version === "v2" ? "portcallnotification-v2" : "portcallnotification";
  let url=`/email/${endpoint}?agentOnly=${agentOnly}&pcid=${pcid}&hqOnly=${hqOnly}`;
  if(showCompletedBerth){
    url+=`&showCompletedBerth=${showCompletedBerth}`;
  }
  const response = await axiosServices.get(`${url}`);
  return response;
};
